module.exports = __webpack_public_path__ + "img/qCode.499f9ce7.png";